import { toast } from "react-toastify";
import {
  getJwtToken,
  setJwtToken,
  getForceChangePassword,
} from "../app/services/auth.service";
import { dayjs, qs } from "dayjs";
import { showToastMessage } from "../app/utility/toastHelper";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import React from "react";
export default function setupAxios(axios, history) {
  let isUnauthorized = false;
  axios.interceptors.request.use(
    (config) => {
      const urlSplitted = config.url.split("/");
      const serviceName = urlSplitted[urlSplitted.length - 1];

      //check jwt validation
      if (
        serviceName != "GetCartableNotification" &&
        serviceName != "SetFavoriteReport" &&
        serviceName != "GetGroupsWithSubReports" &&
        serviceName != "UpdateUserDashboardsConfig" &&
        serviceName != "GetMenus" &&
        serviceName !== "GetLoanCommentsChanges" &&
        serviceName !== "GetNotifications" &&
        serviceName !== "ConfirmTheUserSeen" &&
        serviceName !== "GetLoanComments" &&
        serviceName !== "SendMessage" &&
        serviceName !== "GetBankByPrefix"
      ) {
        document.body.getElementsByClassName(
          "MuiBackdrop-root"
        )[0].hidden = false;
      }

      if (getJwtToken()) {
        config.headers.Authorization = `Bearer ${getJwtToken()}`;
      }

      config.paramsSerializer = (params) =>
        qs.stringify(params, {
          serializeDate: (date) => dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ"),
        });

      return config;
    },
    (err) => {
      // const urlSplitted = config.url.split("/");
      // const serviceName = urlSplitted[urlSplitted.length - 1];

      // if (serviceName != "GetCartableNotification") {
      //   document.body.getElementsByClassName("MuiBackdrop-root")[0].hidden = true;
      // }
      document.body.getElementsByClassName("MuiBackdrop-root")[0].hidden = true;
      Promise.reject(err);
    }
  );
  axios.interceptors.response.use(
    async function(response) {
      // پنهان کردن لودینگ
      const urlSplitted = response.config.url.split("/");
      const serviceName = urlSplitted[urlSplitted.length - 1];

      if (serviceName !== "GetCartableNotification") {
        document.body.getElementsByClassName(
          "MuiBackdrop-root"
        )[0].hidden = true;
      }

      // بررسی blob برای سرویس‌های فایل
      if (
        response.config.responseType === "blob" &&
        response.data instanceof Blob
      ) {
        const contentType = response.data.type;

        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch {
            data = {
              isSuccess: false,
              messages: [{ message: "خطای ناشناخته" }],
            };
          }

          if (!data.isSuccess) {
            const messages =
              data.messages?.map((m) => m.message).join("\n") || "خطا در اجرا";
            toast.error(messages);
            return Promise.reject(data);
          }
        } else {
          // فایل صحیح، مستقیم return
          return response;
        }
      }

      // پردازش پاسخ JSON معمولی
      const { data } = response;

      if (
        serviceName === "ExportLoanRequests" ||
        serviceName === "ExportLoanRegisterRequests" ||
        serviceName === "ExportInstallmentCheques" ||
        serviceName === "GetOnlineInstallmentReportExcel" ||
        serviceName === "GetPaymentRequestExcelInfo" ||
        serviceName === "GetPaymentSettlementZipFile"
      ) {
        return data;
      } else if (!data.isSuccess) {
        const messageErr =
          data.messages?.map((m) => m.message).join("\r\n") || "";
        if (window.location.hash !== "#/otp" && messageErr) {
          toast.error(messageErr, {
            autoClose: data.autoClose > 0 ? data.autoClose : false,
            closeButton: true,
            className: "newLineToast",
          });
        }
      }

      return response;
    },
    function(error) {
      const urlSplitted = error.response?.config.url.split("/") || [];
      const serviceName = urlSplitted[urlSplitted.length - 1] || "";

      if (
        getJwtToken() &&
        error.response?.status !== 401 &&
        serviceName !== "GetCartableNotification"
      ) {
        toast.error("مشکل در اجرای برنامه");
      }

      if (error.response?.status === 401) {
        if (
          error.response.config.headers.Authorization &&
          getJwtToken() &&
          !isUnauthorized
        ) {
          isUnauthorized = true;
          toast.error(
            "مدت زمان استفاده شما از سیستم به پایان رسیده است. لطفا مجدد وارد شوید"
          );
          error.response.config.headers.Authorization = "";
        }
        window.location.href = "#/login";
        setJwtToken("");
        localStorage.clear();
        sessionStorage.clear();
      } else if (error.response?.status === 403) {
        const errorMessage =
          error.response?.data?.messages || "دسترسی شما مجاز نیست.";
        const autoClose = error.response?.data?.autoClose;
        showToastMessage(errorMessage, autoClose);
      } else if (error.response?.status === 429) {
        const errorMessage =
          error.response?.data?.messages ||
          "تعداد درخواست‌های شما بیش از حد مجاز است، لطفا بعداً تلاش کنید.";
        const autoClose = error.response?.data?.autoClose;
        showToastMessage(errorMessage, autoClose);
      }

      document.body.getElementsByClassName("MuiBackdrop-root")[0].hidden = true;
      return Promise.reject(error);
    }
  );
}
